export default class ChangesHistoryDialogController {
  constructor(
    $log, $window, $mdDialog, changes, printAction
  ) {
    'ngInject';
    this.$log = $log;
    this.$window = $window;
    this.$mdDialog = $mdDialog;
    this.changes = Object.assign([], changes);
    this.printAction = printAction;
  }

  print() {
    this.$window.open(this.printAction, '_blank');
  }

  closeDialog() {
    this.$mdDialog.hide();
  }
}
